<template>
  <pt-customer-detail class="pt-customer-detail__page"></pt-customer-detail>
</template>

<script>
import PtCustomerDetail from 'cps/customer-manage/pt-customer-detail/withData'
export default {
  name: 'pt-customer-detail__view',
  components: {
    'pt-customer-detail': PtCustomerDetail
  }
}
</script>
